


































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IWizard } from "../../../../../domain/format";
import {
  NewLatestQuotedDocumentEditorMixin,
} from "../../mixins";
import { DocumentEditor, FormatSelectView } from "../../../editor/wizard";
import LoadedDocumentPreprocessor from "../../LoadedDocumentPreprocessor.vue";
import { PatientFindView } from "../../../../patient/selectors/wizard/guest";

@Component({
  components: {
    DocumentEditor,
    LoadedDocumentPreprocessor,
    PatientFindView,
    FormatSelectView,
  },
})
export default class NewLatestQuotedDocumentEditor extends Mixins(NewLatestQuotedDocumentEditorMixin) {
  @Prop()
  isRegistered: boolean;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop()
  authenticate: (isForcibly: boolean) => Promise<boolean>;

  @Prop()
  wizard: IWizard;
}
